import Switch from '@components/v2/form/Switch/Switch';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { PaymentGatewaySectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const PaymentGatewaySectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: PaymentGatewaySectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_PAYMENT_GATEWAY)}
      description={LangEnum.PAYMENT_REQUIRE_GATEWAY_WITHIN_TECEO_DESCRIPTION}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(LangEnum.PAYMENT_REQUIRE_RELEASE_PRE_ORDER)}
          name="requirePaymentReleaseForPreOrder"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.requirePaymentReleaseForPreOrder}
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'requirePaymentReleaseForPreOrder' })
          }
        />
        <Switch
          label={translate(LangEnum.PAYMENT_REQUIRE_RELEASE_READY_FOR_DELIVERY)}
          name="requirePaymentReleaseForImmediate"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.requirePaymentReleaseForImmediate}
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'requirePaymentReleaseForImmediate' })
          }
        />
      </Stack>
    </SettingContainer>
  );
};

export default PaymentGatewaySectionGeneralSettings;
